module.exports = __webpack_public_path__ + "deea79a0e613180b26a717f4adc165d6.svg";